import type { FC, SVGProps } from 'react'

export const UserSwitch: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9224 20.2705C19.6838 20.2705 21.9224 18.0319 21.9224 15.2705C21.9224 12.5091 19.6838 10.2705 16.9224 10.2705C14.1609 10.2705 11.9224 12.5091 11.9224 15.2705C11.9224 18.0319 14.1609 20.2705 16.9224 20.2705Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.89746 25.1953C9.64985 23.7133 10.7979 22.4686 12.2144 21.5992C13.6309 20.7298 15.2604 20.2695 16.9225 20.2695C18.5845 20.2695 20.2141 20.7298 21.6305 21.5992C23.047 22.4686 24.1951 23.7133 24.9475 25.1953"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.9224 16.2705L28.9224 19.2705L31.9224 16.2705"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.92236 16.2705L4.92236 13.2705L7.92236 16.2705"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.9225 19.2704V16.2704C28.9253 13.6778 28.0884 11.1539 26.5369 9.07665C24.9855 6.99939 22.803 5.48046 20.3162 4.74722C17.8294 4.01398 15.172 4.10588 12.7418 5.00914C10.3115 5.91241 8.23919 7.57846 6.83496 9.75793"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.92237 13.2705V16.2705C4.91954 18.8632 5.75648 21.387 7.3079 23.4643C8.85932 25.5415 11.0418 27.0605 13.5286 27.7937C16.0154 28.5269 18.6728 28.4351 21.1031 27.5318C23.5333 26.6285 25.6056 24.9625 27.0099 22.783"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
